import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.number.constructor";
import _inRange from "lodash/inRange";
import _find from "lodash/find";
import _get from "lodash/get";

var _LOAN_PROGRAM_NAME;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { LOAN_PURPOSE_PURCHASE, LOAN_PROGRAM_FIXED_30, LOAN_PROGRAM_FIXED_20, LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_10, LOAN_PROGRAM_ARM_7_1, LOAN_PROGRAM_ARM_5_1, LOAN_PROGRAM_ARM_3_1 } from '../config/data/constants';
import { creditScoreRange } from '../config/data/ranges';
/**
 * Unsure. Probably unused.
 * @todo unused?
 * @private
 * @deprecated
 */

export var getLowerBoundFromRangeById = function getLowerBoundFromRangeById(ranges, id) {
  return _get(_find(ranges, {
    id: Number(id)
  }), 'range[0]');
};
/**
 * Unsure. Probably unused.
 * @todo unused?
 * @private
 * @deprecated
 */

export var getFromRangeByValue = function getFromRangeByValue(ranges, value) {
  return _find(ranges, function (_ref) {
    var _ref$range = _slicedToArray(_ref.range, 2),
        min = _ref$range[0],
        max = _ref$range[1];

    return _inRange(value, min, max + 1);
  });
};
/**
 * Lookup object for human friendly loan program names. Keys are LOAN_PROGRAM constants
 * @see getLoanProgramName
 * @deprecated
 */

export var LOAN_PROGRAM_NAME = (_LOAN_PROGRAM_NAME = {}, _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_30, '30-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_20, '20-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_15, '15-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_10, '10-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_7_1, '7/1 ARM'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_5_1, '5/1 ARM'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_3_1, '3/1 ARM'), _LOAN_PROGRAM_NAME);
/**
 * Gets a human friendly description of a loan program
 * @example
 * import { LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_ARM_5_1 } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanProgramName } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanProgramName(LOAN_PROGRAM_FIXED_15); // 15-year fixed
 * getLoanProgramName(LOAN_PROGRAM_ARM_5_1); // 5/1 ARM
 * @function
 * @param  {external:home-constants.LOAN_PROGRAM} loanProgram
 * @return {String}
 */

export var getLoanProgramName = function getLoanProgramName(loanProgram) {
  return _get(LOAN_PROGRAM_NAME, loanProgram, loanProgram);
};
/**
 * Is the purpose of this loan purchasing a home
 * @example
 * import { LOAN_PURPOSE_PURCHASE, LOAN_PURPOSE_REFINANCE } from '@nerdwallet/home-app-lib/constants';
 * import { isPurchase } from '@nerdwallet/home-app-lib/helpers';
 *
 * isPurchase({ loanPurpose: LOAN_PURPOSE_PURCHASE }); // true
 * isPurchase({ loanPurpose: LOAN_PURPOSE_REFINANCE }); // false
 * @function
 * @param  {Object}  data
 * @param  {external:home-constants.LOAN_PURPOSE}  data.loanPurpose  The purpose of the loan, LOAN_PURPOSE_PURCHASE or LOAN_PURPOSE_REFINANCE
 * @return {Boolean}      true if Purchase, false if Refinance
 */

export var isPurchase = function isPurchase(data) {
  return _get(data, 'loanPurpose') === LOAN_PURPOSE_PURCHASE;
};
/**
 * Get the loan amount.  This should only be used for approximating the loan amount, and never
 * for an actual mortgage offer, as offers may roll fees into the loan amount
 * @todo Potentially incorrect.  Where / why is this used?
 * @example // for Refi
 * import { LOAN_PURPOSE_REFINANCE } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanAmount } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_REFINANCE,
 *   mortgageBalance: 50,
 *   cashout: 10,
 * }); // 60
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_REFINANCE,
 *   mortgageBalance: 50,
 * }); // 50
 *
 * @example // for Purchase
 * import { LOAN_PURPOSE_PURCHASE } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanAmount } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_PURCHASE,
 *   purchasePrice: 50,
 *   downPayment: 10,
 * }); // 40
 * @function
 * @param  {Object} data
 * @param  {external:home-constants.LOAN_PURPOSE} data.loanPurpose  The purpose of the loan, LOAN_PURPOSE_PURCHASE or LOAN_PURPOSE_REFINANCE
 * @param  {Number} [data.purchasePrice]  Required if loanProgram=purchase. The purchase price of the property.
 * @param  {Number} [data.downPayment]  Required if loanProgram=purchase. The down payment for the loan
 * @param  {Number} [data.mortgageBalance]  Required if loanProgram=refinance. The user's current mortgage balance
 * @param  {Number} [data.cashout=0]  Required if loanProgram=refinance. The amount of cashout the user requested
 * @return {Number}      The amount of the loan
 */

export var getLoanAmount = function getLoanAmount(data) {
  if (isPurchase(data)) {
    return _get(data, 'purchasePrice') - _get(data, 'downPayment');
  }

  return _get(data, 'mortgageBalance') + _get(data, 'cashout', 0);
};
/**
 * Print the credit score range for when you need to display the user's credit score but you only have a range value.
 * @example
 * import { getCreditScoreRange } from '@nerdwallet/home-app-lib/helpers';
 *
 * getCreditScoreRange(301); // 300 - 579
 * getCreditScoreRange(640); // 640 - 659
 * getCreditScoreRange(760); // 760+
 * getCreditScoreRange('test'); // ''
 * @function
 * @param  {Number}  creditScore
 * @return {String}  string representation of credit score range
 */

export var getCreditScoreRange = function getCreditScoreRange(creditScore) {
  for (var i = 0; i < creditScoreRange.length; i += 1) {
    var range = creditScoreRange[i];

    if (!range[1] && creditScore >= range[0]) {
      return "".concat(range[0], "+");
    }

    if (range[1] && creditScore <= range[1] && creditScore >= range[0]) {
      return "".concat(range[0], " - ").concat(range[1]);
    }
  }

  return '';
};